import UpdatePriceViaImport from "@/components/inventory/ProductsPriceUpdateViaImport"

const InventoryConfigurationPage = () => {
  return (
    <section className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="grid sm:grid-cols-1 lg:grid-cols-3">
            <UpdatePriceViaImport />
          </div>
        </div>
      </div>
    </section>
  )
}

export default InventoryConfigurationPage
